// 효과 관련 유틸리티 함수들
class EffectUtils {
  // 공격 범위 시각화 색상 변경
  static updateAttackVisualColor(attackVisualMesh, isEnemyInRange) {
    if (!attackVisualMesh) return;

    if (isEnemyInRange) {
      attackVisualMesh.material.color.setHex(0xff4444);
      attackVisualMesh.material.opacity = 0.4;
    } else {
      attackVisualMesh.material.color.setHex(0x44ff44);
      attackVisualMesh.material.opacity = 0.2;
    }
  }
}

// webpack 빌드를 위해 default export 추가
export default EffectUtils;

// 전역 변수로도 등록 (기존 코드 호환성)
window.EffectUtils = EffectUtils;